import { reduxForm } from 'redux-form';
import Component from './FormChangePassword.jsx';
import { validate, initialValues } from './validate';

export default reduxForm({
  form: 'changePasswordForm',
  initialValues,
  validate,
})(Component);
